import { IApiError, ITransportError } from "../api.interfaces";

export const ERROR_TYPES = {
    OVERLIMIT: "OverLimitException",
    DB_UNAVAILABLE: "DbUnavailableException",
    INVALID_USER: "InvalidUserException",
    NETWORK_ERROR: "NetworkError"
};

export function isServerUnavailableException(errorObject?: IApiError) {
    return errorObject?.data?.type === "DbUnavailableException";
}

export function isOverLimitException(errorObject?: IApiError) {
    return errorObject?.data?.type === "OverLimitException";
}

export function isInvalidSessionException(errorObject?: IApiError) {
    return errorObject?.data?.type === "InvalidUserException" || errorObject?.data?.type === "InvalidMyAdminUserException" || errorObject?.data?.type === "ExpiredPasswordException";
}

export function isArgumentException(errorObject?: IApiError) {
    return errorObject?.data?.type === "ArgumentException";
}

export function isArgumentNullException(errorObject?: IApiError) {
    return errorObject?.data?.type === "ArgumentNullException";
}

export function isDuplicateException(errorObject?: IApiError) {
    return errorObject?.data?.type === "DuplicateException";
}

export function isGenericException(errorObject?: IApiError) {
    return errorObject?.data?.type === "GenericException";
}

export function isInvalidApiOperationException(errorObject?: IApiError) {
    return errorObject?.data?.type === "InvalidApiOperationException";
}

export function isInvalidOperationException(errorObject?: IApiError) {
    return errorObject?.data?.type === "InvalidOperationException";
}

export function isInvalidPermissionsException(errorObject?: IApiError) {
    return errorObject?.data?.type === "InvalidPermissionsException";
}

export function isNetworkError(error?: XMLHttpRequest | ITransportError){
    return (error && (error as ITransportError).data && (error as ITransportError).data.type === ERROR_TYPES.NETWORK_ERROR) || (error instanceof XMLHttpRequest);
}

/** Transient errors worth retrying rather than surfacing (network / over-limit / server-unavailable). */
export function isTransientSyncError(error?: IApiError): boolean {
    return isNetworkError(error) || isOverLimitException(error) || isServerUnavailableException(error);
}

export function isNotSupportedException(errorObject?: IApiError) {
    return errorObject?.data?.type === "NotSupportedException";
}

export function isRelationViolatedException(errorObject?: IApiError) {
    return errorObject?.data?.type === "RelationViolatedException";
}

export function isInvalidRequestException(errorObject?: IApiError) {
    return errorObject?.data?.type === "InvalidRequestException";
}

export function isMissingDeviceEulaAcceptanceException(errorObject?: IApiError) {
    return errorObject?.data?.type === "MissingDeviceEulaAcceptanceException";
}